import { Component } from '@angular/core';

@Component({
  selector: 'menu-profile',
  templateUrl: 'menu-profile.html'
})
export class MenuProfileComponent {

  constructor() {}

}



// WEBPACK FOOTER //
// ./src/components/menu-profile/menu-profile.ts